import { getDefaultInsurance } from "."
import { getDefaultDependent, planHasSubmittedInsurance } from "../../../util"

export default function getFormValues(user, plan, individuals, inputCurrentStep = 0) {
	const name = "insuranceForm"
	const hasInsurance = plan?.healthInsurancePending || plan?.healthInsuranceComplete ? "Yes" : ""
	const dependent = getDefaultDependent(user)
	const insurance = getDefaultInsurance(plan, individuals)
	let currentStep = inputCurrentStep
	const signupStatus = plan?.signupStatus || {}
	
	// Check if plan has at least one health insurance with submittedTs
	// Whether the plan has at least one submitted insurance
	const hasSubmittedInsurance = planHasSubmittedInsurance(user, plan)
		
	return {
		name,
		hasInsurance,
		hasSubmittedInsurance,
		dependent,
		...insurance,
		currentStep,
		signupStatus
	}
}